module.exports = __webpack_public_path__ + "media/images/card_diners-698aa6d101f331d1625671cbc4d072be.jpg";